import React from "react";
import {css} from "@panda/css";

import {googlePlacesDivId} from "../../../search/utils/search_constants";
import {HomepageHeroDesktopSearch} from "./HomepageHeroDesktopSearch";
import {HomepageHeroMobileSearch} from "./HomepageHeroMobileSearch";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageHeroSearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={heroSectionHolderStyle}>
            <div id={googlePlacesDivId} />
            <HomepageHeroDesktopSearch {...props} />
            <HomepageHeroMobileSearch {...props} />
        </div>
    );
};

const heroSectionHolderStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",

    "& > div:not(#google_places_tab_results)": {
        width: "100%",
        alignSelf: "center"
    }
});
import React from "react";
import {css} from "@panda/css";

import {googlePlacesDivId} from "../../../search/utils/search_constants";
import {HomepageHeroDesktopSearch} from "./HomepageHeroDesktopSearch";
import {HomepageHeroMobileSearch} from "./HomepageHeroMobileSearch";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageHeroSearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={heroSectionHolderStyle}>
            <div id={googlePlacesDivId} />
            <HomepageHeroDesktopSearch {...props} />
            <HomepageHeroMobileSearch {...props} />
        </div>
    );
};

const heroSectionHolderStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",

    "& > div:not(#google_places_tab_results)": {
        width: "100%",
        alignSelf: "center"
    }
});
